class Preloader{
    html =
        '<div class="progressbar-wrap">' +
        '<div class="progress shadow" role="progressbar" aria-label="Animated striped example" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100">' +
        '<div class="progress-bar progress-bar-striped progress-bar-animated" style="width: 0%"></div>' +
        '</div>' +
        '</div>'
    ;
    constructor() {
        this.$el = $(this.html)
        this.$container = $('body')
    }
    currentProgress = 0
    hideTimeoutId = 0
    showTimeoutId = 0

    show(){
        clearTimeout(this.hideTimeoutId)
        clearTimeout(this.showTimeoutId)

        this.showTimeoutId = setTimeout(function (){
            this.$container.append(this.$el)
        }.bind(this), 1000);
    }
    progress(percent){
        this.currentProgress = percent
        this.$el.find('[role="progressbar"').attr('aria-valuenow', percent);
        this.$el.find('.progress-bar').width(`${percent}%`)
    }
    hide(){
        clearTimeout(this.showTimeoutId)

        if(this.currentProgress < 90){
            this.progress(100)
            this.hideTimeoutId = setTimeout(function (){
                this.hide()
            }.bind(this), 1000)
        }else{
            this.$el.remove();
            this.progress(0)
        }
    }
}

module.exports = new Preloader();